import { useContext, useEffect } from "react"
import { AppContext } from "../../context/AppContext"
import { MapContext } from "../../context/MapContext";
import { inflowBgLayers, inflowLayers } from "./layers";
import { Style, Fill } from 'ol/style';
import GeoJSON from 'ol/format/GeoJSON';
import InoutflowLegend from "../legend/InoutflowLegend";
import BottomBox from './../bottomBox/BottomBox';
import { abstractFetch } from "../../common/func/abstractFetch";
import { cql2filter } from "../../common/func/cql2filter";

export default function InflowMap() {
  const {step, mapMode, setBackdropOpen} = useContext(AppContext);
  const { inLegendControlOpen, setInLegendControlOpen,
          inCollapseBgMap, setInCollapseBgMap,
          inHubGridOpacity, setInHubGridOpacity,
          inflowBgMap, setInflowBgMap,
          inflowIndex, setInflowIndex,
					inflowIndexInput,
          zoomLevel, 
					createMap,
          handleInflowIndexInput,
          inflowMapRef
        } = useContext(MapContext);

  const handleInflowView = (type) => {
    const value = type === 'plus' ? 1 : -1;
    inflowMapRef.current
      .getView()
      .setZoom(inflowMapRef.current.getView().getZoom() + value);
  };

	const pointerInHubFeature = (e) => {
		inflowMapRef.current.forEachFeatureAtPixel(e.pixel, inPointerMoveCallBack);
	};

	let inSelected = null;
	const inPointerMoveCallBack = (selectedFeature, layer) => {
		if (layer.get('title') === '유입 중심거점') {
			inSelected = selectedFeature;
			const inFlowSelectFeatureColor = new Style({
				// fill: new Fill({ color: '#f5d000', opacity: '1' }),
				fill: new Fill({ color: '#537b35', opacity: '1' }),
			});
			selectedFeature.setStyle(inFlowSelectFeatureColor);
			return true;
		} else {
		}
	};

	useEffect(() => {
		setBackdropOpen(true);
		
		inflowMapRef.current = createMap(
			'inMap',
			Object.keys(inflowBgLayers).map((key) => inflowBgLayers[key]),
			Object.keys(inflowLayers).map((key) => inflowLayers[key])
		)

		inflowMapRef.current.on('pointermove', (e) => {
			if (inSelected !== null) {
				inSelected.setStyle(undefined);
				inSelected = null;
			}
			pointerInHubFeature(e);
		});

		const fetchXmlString = async (inflowIndex) => {
			const indexXmlString = await cql2filter(
				'pc_in_val>=' + inflowIndex
			);

			const indexFeatureRequest = {
				service: 'WFS',
				version: '1.0.0',
				request: 'GetFeature',
				outputFormat: 'application/json',
				srsName: 'EPSG:3857',
				typeName: 'pinogio:flow_pc_grid_2021',
				filter: indexXmlString,
			}; 

			abstractFetch(indexFeatureRequest)
				.then((res) => {
					inflowLayers.centralHubV.getSource().clear();
					inflowLayers.centralHubV
						.getSource()
						.addFeatures(new GeoJSON().readFeatures(res));

						setBackdropOpen(false);
			});

				const inMapZoom = inflowMapRef.current.getView().getZoom();
				
				if (inMapZoom <= 11) {
					inflowLayers.centralHubT
						.getSource()
						.updateParams({ filter: await cql2filter(`pc_in_val>=${inflowIndex}`) });
					inflowLayers.centralHubT.getSource().refresh();
				}
		}
		fetchXmlString(inflowIndex)
	}, []);

	useEffect(() => {
		setInflowIndex(inflowIndexInput);
	}, [inflowIndexInput]);

	useEffect(() => {
		const fetchXmlString = async (inflowIndex) => {
			const indexXmlString = await cql2filter(
				'pc_in_val>=' + inflowIndex
			);

			const indexFeatureRequest = {
				service: 'WFS',
				version: '1.0.0',
				request: 'GetFeature',
				outputFormat: 'application/json',
				srsName: 'EPSG:3857',
				typeName: 'pinogio:flow_pc_grid_2021',
				filter: indexXmlString,
			}; 

			abstractFetch(indexFeatureRequest)
				.then((res) => {
				inflowLayers.centralHubV.getSource().clear();
				inflowLayers.centralHubV
					.getSource()
					.addFeatures(new GeoJSON().readFeatures(res));
			});

			inflowLayers.centralHubT
				.getSource()
				.updateParams({ filter: await cql2filter(`pc_in_val>=${inflowIndex}`) });
			inflowLayers.centralHubT.getSource().refresh();
		}
		fetchXmlString(inflowIndex);
	}, [step]);

  return (
    <div
			className={
				mapMode === 'in'
					? 'partition--single'
					: mapMode === 'dual'
					? 'partition'
					: 'partition--invisible'
			}
		>
			<InoutflowLegend
				step={1}
				legendControlOpen={inLegendControlOpen}
				setLegendControlOpen={setInLegendControlOpen}
				collapseBgMap={inCollapseBgMap}
				setCollapseBgMap={setInCollapseBgMap}
				hubGridOpacity={inHubGridOpacity}
				setHubGridOpacity={setInHubGridOpacity}
				flowBgMap={inflowBgMap}
				setFlowBgMap={setInflowBgMap}
				bgLayers={inflowBgLayers}
				flowLayers={inflowLayers}
				target={{
					cssName: 'left',
					color: 'yellowBox',
					name: '유입',
					flowHub: 'inflowHub',
				}}
			/>
			<div id="inMap" className="mapArea" />
			<div className="mapZoom">
				<button onClick={() => handleInflowView('plus')}>
					<img src="img/zoomPlus.png" alt="확대" />
				</button>
				<button onClick={() => handleInflowView('minus')}>
					<img src="img/zoomMin.png" alt="축소" />
				</button>
			</div>

			<div className="mapTit orangeBG">유입 중심 거점</div>

			{/* {zoomLevel < 11 ? ( */}
			<div className="zoomTooltip">
				{zoomLevel < 9
					? '화면을 확대하면 격자의 정보를 볼 수 있습니다.'
					: '격자를 클릭하면 해당 격자의 정보를 확인할 수 있습니다.'}
			</div>
			{/* ) : null} */}
      <BottomBox
            max={65.868}
            flowIndex={inflowIndex}
            flowIndexInput={inflowIndexInput}
            handleFlowIndexInput={handleInflowIndexInput}
            flowLayers={inflowLayers}
            target={{
              mapMode1: 'in',
              mapMode2: 'out',
              name: '유입',
              max1: '65.868',
              base: '0.035는',
              average: '0.14564',
              medium: '0.00216',
              max2: '65.86849',
              textColor: 'orangeText',
              colorBox: 'orangeBox',
            }}
          />
		</div>
  )
}